import * as React from "react";

function BookmarkedIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={14} height={19} fill="none" {...props}>
      <path
        d="M13.5 1.938V18.25l-6.75-3.938L0 18.25V1.937C0 1.023.738.25 1.688.25h10.124c.915 0 1.688.773 1.688 1.688z"
        fill="currentColor"
      />
    </svg>
  );
}

const MemoBookmarkedIcon = React.memo(BookmarkedIcon);
export default MemoBookmarkedIcon;
